export default __webpack_public_path__ + "static/media/shape-back.608e222e.svg";